import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../../shared/utils/api.js'

// Fetch all conversations for a specific user
export const fetchUserConversations = createAsyncThunk(
  'chat/fetchUserConversations',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/v1/chats/user/${userId}`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

// Fetch messages for a specific conversation
export const fetchConversationMessages = createAsyncThunk(
  'chat/fetchConversationMessages',
  async (conversationId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/v1/chats/conversation/${conversationId}`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

// Send a message in a conversation
export const sendChatMessage = createAsyncThunk(
  'chat/sendMessage',
  async ({ conversationId, message }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/v1/chats/conversation/${conversationId}/message`, { message })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

// Mark conversation as read
export const markConversationAsRead = createAsyncThunk(
  'chat/markAsRead',
  async (conversationId, { rejectWithValue }) => {
    try {
      const response = await api.patch(`/v1/chats/conversation/${conversationId}/read`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

// ADMIN CHAT LOG ENDPOINTS

// Fetch chat log users with search and pagination
export const fetchChatLogUsers = createAsyncThunk(
  'chat/fetchChatLogUsers',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get('/v1/admin/chat-logs/users', { params })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

// Load conversation between selected users
export const loadChatConversation = createAsyncThunk(
  'chat/loadConversation',
  async ({ userIds, dateFilter }, { rejectWithValue }) => {
    try {
      const response = await api.post('/v1/admin/chat-logs/load', { userIds, dateFilter })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

// Export chat logs
export const exportChatLogs = createAsyncThunk(
  'chat/exportLogs',
  async ({ userIds, format, dateFilter }, { rejectWithValue }) => {
    try {
      const isBlob = format === 'csv'
      const response = await api.get('/v1/admin/chat-logs/export', {
        params: { userIds, format, dateFilter },
        responseType: isBlob ? 'blob' : 'json',
      })
      return { data: response.data, format }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

// Get GDPR consents
export const getGDPRConsents = createAsyncThunk(
  'chat/getGDPRConsents',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/v1/admin/gdpr/consents/${userId}`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

// Update GDPR consents
export const updateGDPRConsents = createAsyncThunk(
  'chat/updateGDPRConsents',
  async ({ userId, consents, notes }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/v1/admin/gdpr/consents/${userId}`, { consents, notes })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)
